<fui-header-fascia (clicked$)="click()" [disabled]="disabled" [focussed]="focussed" [hovered]="hovered"
                   [ngClass]="'clickable'">
    <fui-fixtures>
        <fui-fixture *ngIf="!disabled">
            <fui-mark-toggle [toggled]="popped" (click)="clickToggle($event)">
                <fui-icon [icon]="'chevron-down'" [height]="8" [width]="8"></fui-icon>
            </fui-mark-toggle>
        </fui-fixture>
        <fui-spanning-fixture>
            <fui-input-dom *ngIf="!disabled || !option || !optionOpenable">
                <input (blur)="onBlur($event)" #input (focus)="onFocus($event)" [ngModel]="option"
                       (ngModelChange)="modelChanged($event)" [ngClass]="{'direct-input': allowDirectInput}"
                       [placeholder]="placeholder | translate" [readonly]="!allowDirectInput" [tabindex]="tabindex"
                       type="text" [attr.inputMode]="isNumeric ? 'decimal' : 'text'"
                       (keydown)="onKeyDown($event)" (keyup)="onKeyUp($event)">
            </fui-input-dom>
            <span class="select-link" *ngIf="disabled && option && optionOpenable" (click)="openOption($event)">{{option}}</span>
        </fui-spanning-fixture>
    </fui-fixtures>
</fui-header-fascia>
<fui-select-pop [popped]="popped" (popped$)="pop($event)">
    <fui-sections>
        <fui-content-section *ngIf="loading && !query">
            <fui-loading>
                <fui-ellipsis-loader></fui-ellipsis-loader>
            </fui-loading>
        </fui-content-section>
        <fui-fab-section *ngIf="searchable()">
            <fui-search-control [label]="'fui.select-control.label.filter' | translate" [(ngModel)]="query"
                                [placeholder]="'fui.select-control.placeholder.filter' | translate"></fui-search-control>
        </fui-fab-section>
        <fui-content-section *ngIf="empty(filteredOptions)">
            <fui-empty>
                <fui-icon [height]="32" [icon]="'search-group'" [width]="32"></fui-icon>
            </fui-empty>
        </fui-content-section>
        <fui-section *ngIf="filled(filteredOptions)">
            <fui-select-options [field]="field" [key]="key" (option$)="value = $event" id="options"
                                [options]="options" [filteredOptions]="filteredOptions"
                                [clearSelectionOptionLabel]="clearSelectionOptionLabel"
                                [allowClearSelectionOption]="allowClearSelectionOption"
                                [optionOpenable]="optionOpenable" (optionOpened$)="optionOpened$.emit($event)"
                                (selection$)="select($event)"></fui-select-options>
        </fui-section>
        <fui-ftb-section *ngIf="ftb()">
            <fui-fragments>
                <fui-fragment *ngIf="addable || extendable || actions">
                    <fui-buttons>
                        <fui-mark-button (click)="extend()" *ngIf="extendable && options.length > 0"
                                         [attr.title]="'fui.common.button.search' | translate"
                                         id="extended-search-button">
                            <fui-icon [height]="12" [icon]="'lookup'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-mark-button (click)="add()" *ngIf="addable"
                                         [attr.title]="'fui.common.button.addNew' | translate"
                                         id="add-new-button">
                            <fui-icon [height]="12" [icon]="'plus'" [width]="12"></fui-icon>
                        </fui-mark-button>
                        <fui-action *ngFor="let a of actions" [disabled]="a.disabled" [attr.title]="a.title | translate"
                                    (click)="actionClicked(a)">
                            <fui-icon [height]="a.iconHeight || 12" [width]="a.iconWidth || 12"
                                      [icon]="a.icon"></fui-icon>
                        </fui-action>
                    </fui-buttons>
                </fui-fragment>
                <fui-fragment *ngIf="limited()">
                    <fui-limit-total [limit]="filteredOptions.length" [total]="total"></fui-limit-total>
                </fui-fragment>
            </fui-fragments>
        </fui-ftb-section>
    </fui-sections>
</fui-select-pop>
